import React from 'react';
import Separator from '../Separator';
import Item from '../Item';
import { separatorString, itemClassName, separatorClassName, } from '../../constants';
import { getItemId } from '../../helpers';
function MenuItems({ children, itemClassName: _itemClassName = '', refs, separatorClassName: _separatorClassName = '', }) {
    const childArray = React.Children.toArray(children).filter(Boolean);
    const itemsCount = childArray.length;
    const itemClass = React.useMemo(() => `${itemClassName} ${_itemClassName}`, [_itemClassName]);
    const separatorClass = React.useMemo(() => `${separatorClassName} ${_separatorClassName}`, [_separatorClassName]);
    return (React.createElement(React.Fragment, null, childArray.map((child, index) => {
        const id = getItemId(child);
        const separatorId = id + separatorString;
        const isLastItem = index + 1 === itemsCount;
        return [
            React.createElement(Item, { className: itemClass, id: id, key: 'menuItem__' + id, refs: refs, index: index }, child),
            !isLastItem && (React.createElement(Separator, { className: separatorClass, id: separatorId, refs: refs, key: separatorId, index: index + 0.1 })),
        ];
    })));
}
export default MenuItems;
